import React, { useContext, Fragment } from "react";
import _ from "lodash";
import { convertNum, isDisplayable } from "util/misc";
import { PlayByPlayContext } from "games/model/PlayByPlayContext";
import FootballFields from "./FootballFields";
import { midStatsChanges } from "../model/midStats";
import { getOppositeSide } from "games/utils";

const TeamStatsEdit = ({
  side,
  activeTeamStats,
  setActiveTeamStats,
  otherTeamStats,
  setOtherTeamStats
}) => {
  const {
    usePlayByPlay: [state, dispatch]
  } = useContext(PlayByPlayContext);
  const { game } = state;
  const schoolName = _.get(game, [side, "season", "team", "school", "name"]);

  const handleInputChange = (event, name) => {
    if (!name) return;
    const value = isDisplayable(event.target.value) ? event.target.value : null;
    const transformedStats = {
      ...activeTeamStats,
      [name]: convertNum(value)
    };

    const transformedActiveTeamStats = {
      ...transformedStats,
      ...midStatsChanges(name, transformedStats)
    };
    const transformedOtherTeamStats = {
      ...otherTeamStats,
      ...(name === "totalPoints" && { pointsAllowed: value }),
      ...(name === "totalYards" && { yardsAllowed: value })
    };

    setActiveTeamStats(transformedActiveTeamStats);
    setOtherTeamStats(transformedOtherTeamStats);
  };

  // dispatch on input blur instead of on input change to help with performance --
  // since blur happens less often
  const handleInputBlur = () => {
    dispatch({
      type: "editTeamStats",
      payload: {
        [side]: activeTeamStats,
        [getOppositeSide(side)]: otherTeamStats
      }
    });
  };

  return (
    <Fragment>
      <h4>Edit Team Stats for {schoolName}</h4>
      <FootballFields
        handleInputChange={handleInputChange}
        activeEntity={activeTeamStats}
        handleInputBlur={handleInputBlur}
      />
    </Fragment>
  );
};

export default TeamStatsEdit;
